// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"projectsSearch_searchInput__1YEqP","searchBtn":"projectsSearch_searchBtn__YYUve"};